import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import * as analytics from 'analytics/Analytics';
import * as NewUserFlowActions from 'onboarding/new-user-flow/NewUserFlowActions';
import {
  SIGNUP_FLOW_V2_ACADEMIC_ROLE_INFO_SCREEN,
  SIGNUP_FLOW_V2_INDUSTRY_ROLE_INFO_SCREEN,
} from 'onboarding/new-user-flow/NewUserFlowConstants';
import InfoSidePanel from 'onboarding/new-user-flow/signup-flow-v2/InfoSidePanel';
import SignupScreen from 'onboarding/new-user-flow/signup-flow-v2/SignupScreen';
import SignupScreenCard from 'onboarding/new-user-flow/signup-flow-v2/SignupScreenCard';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';

function AffiliationButtonPanel(): JSX.Element {
  const academicBodyText = 'I work in a research lab at an academic, non-profit, or government institution';
  const industryBodyText = 'I work in R&D for a biotech or pharmaceutical company';
  const handleClickAcademic = (): void => {
    analytics.track('onboarding_page', 'clicked', {
      page: 'affiliation',
      objectClicked: 'button',
      objectText: 'Academic',
      eventLastModified: 'FY22_Q2b3',
    });
    NewUserFlowActions.showScreen(SIGNUP_FLOW_V2_ACADEMIC_ROLE_INFO_SCREEN);
  };
  const handleClickIndustry = (): void => {
    analytics.track('onboarding_page', 'clicked', {
      page: 'affiliation',
      objectClicked: 'button',
      objectText: 'Industry',
      eventLastModified: 'FY22_Q2b3',
    });
    NewUserFlowActions.showScreen(SIGNUP_FLOW_V2_INDUSTRY_ROLE_INFO_SCREEN);
  };
  return (
    <div className={css(styles.buttonPanel)}>
      <SignupScreenCard
        titleText="Academic"
        bodyText={academicBodyText}
        imagePath="/static/img/new-user-flow/affiliation-academic.png"
        onClick={handleClickAcademic}
        buttonText="I work in Academia"
      />
      <SignupScreenCard
        titleText="Industry"
        bodyText={industryBodyText}
        imagePath="/static/img/new-user-flow/affiliation-industry.png"
        onClick={handleClickIndustry}
        buttonText="I work in Industry"
      />
    </div>
  );
}

export default function AffiliationScreen(): JSX.Element {
  const titleText = 'What type of work do you do?';
  const bodyText = 'We help scientists across various organizations accelerate their research.';
  return (
    <SignupScreen>
      <Row className={css(styles.row)}>
        <Col xs={4} sm={6}>
          <InfoSidePanel titleText={titleText} bodyText={bodyText} />
        </Col>
        <Col xs={8} sm={6} className={css(styles.cardColumn)}>
          <AffiliationButtonPanel />
        </Col>
      </Row>
    </SignupScreen>
  );
}

const styles = StyleSheet.create({
  row: {
    marginLeft: '52px',
    marginRight: '52px',
    height: '100%',
  },
  cardColumn: {
    height: '100%',
  },
  buttonPanel: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    height: '100%',
    padding: '20px 0',
  },
});
